import { GashTransactionType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const gashTransactionTypeName: { [key in GashTransactionType]: TKeyType } = {
  [GashTransactionType.GASH_STORE_REDEEM]: 'common.redeem',
  [GashTransactionType.TRANSFER_TO_GA]: 'common.transferIn',
  [GashTransactionType.SYSTEM_DEPOSIT]: 'common.systemDeposit',
  [GashTransactionType.ACTIVITY]: 'common.activity',
  [GashTransactionType.GIFT]: 'common.gift',
  [GashTransactionType.GRANT_BY_ADMIN]: 'common.grant',
  [GashTransactionType.RECLAIM_BY_ADMIN]: 'common.reclaim'
}

export default gashTransactionTypeName
